const Spinner = () => (
  <div className="flex justify-center py-10"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600" /></div>
);
export default Spinner;
